import React from "react";
import { t } from "../../../../../utils/i18n";

const TradeAlerts = ({
  isDisputed,
  isSeller,
  acceptSuccess,
  isBuyer,
  paidSuccess,
  onClose
}) => {


    return (
      <div className="tradealerts-cont">
        {!isDisputed && (
          <div className="tradedetails-error" id="createtrade-alert">
            <button type="button" className="close" data-dismiss="createtrade-error" onClick={() => {onClose('createtrade-alert')}}>
              &times;
            </button>
            <span className="tradealerts-cont-text">{t("p2p.trade_alerts.keep_chat")}
            </span>
          </div>
        )}
        {isDisputed && (
          <div className="tradedetails-error" id="disputerequest-alert">
            <button type="button" className="close" data-dismiss="createtrade-error" onClick={() => {onClose('disputerequest-alert')}}>
              &times;
            </button>
            <span className="tradealerts-cont-text">{t("p2p.trade_alerts.dispute_submitted")}
            </span>
          </div>
        )}
        {isSeller && acceptSuccess && (
          <div className="tradedetails-success" id="releaseusd-alert">
            <button type="button" className="close" data-dismiss="alert" onClick={() => {onClose('releaseusd-alert')}}>
              &times;
            </button>
            <span className="tradealerts-cont-text">
            {t("p2p.trade_alerts.released")}
            </span>
          </div>
        )}
        {isBuyer && paidSuccess && (
          <div className="tradedetails-success" id="paidsuccess-alert">
            <button type="button" className="close" data-dismiss="alert" onClick={() => {onClose('paidsuccess-alert')}}>
              &times;
            </button>
            <span className="tradealerts-cont-text">
            {t("p2p.trade_alerts.paid")}
            </span>
          </div>
        )}
      </div>
    )
}
export default TradeAlerts;
